import { PersonalInformation } from '@app/model/implementation/PersonalInformation';
import { ICalculationCode } from '@app/model/interfaces/ICalculationCode';
import { IServicePersonalInformation } from '@app/model/interfaces/IServicePersonalInformation';
import { IState } from '@app/model/interfaces/IState';
import { IWithholdingStatus } from '@app/model/interfaces/IWithHoldingstatus';
import { IEmployeeService } from '@app/services/interface/IEmployeeService';

export class MockW4Service implements IEmployeeService {
  constructor() {}

  public getEmployee(id: number): Promise<PersonalInformation> {
    const promise = new Promise<PersonalInformation>((resolve) => {
      const info = Promise.resolve({
        addedTimestamp: '2019-09-17T15:35:21.287Z',
        addedUserId: 88845,
        address: 'address',
        address2: 'address2',
        city: 'city',
        employeeId: 'employeeId or Driver code',
        federalWithholding: 'MARRIED',
        federal_allowances: 0,
        federalAdditionallWithholdingAmount: 0,
        federalExempt: true,
        federalTwoJobsTotal: true,
        federalQualifiedChildrenCount: 0,
        federalQualifiedChildrenAmount: 0,
        federalOtherDependentsCount: 0,
        federalOtherDependentsAmount: 0,
        federalTotalClaimAmount: 0,
        federalOtherIncomeAmount: 0,
        federalDeductionsAmount: 0,
        firstName: 'John',
        id: 18602,
        lastName: 'Doe',
        objectVersion: 0,
        scribeError: null,
        ssn: '*******11',
        state: 'UT',
        stateWithholding: 'MFJ1I',
        stateDependents: 0,
        stateAdditionallWithholdingAmount: 0,
        updatedTimestamp: '2019-09-17T15:35:21.287Z',
        updatedUserId: 88845,
        updatedToScribe: false,
        updatedToScribeDate: '2019-09-17T00:00:00Z',
        updatedToScribeStatus: null,
        zip: '30021',
      });
      info.then((data: any) => {
        const employee: PersonalInformation = new PersonalInformation(data);
        resolve(employee);
      });
    });
    return promise;
  }

  public getStates(): Promise<IState[]> {
    const promise = new Promise<IState[]>((resolve) => {
      resolve([
        { state: 'AK', country: 'USA ' },
        { state: 'AL', country: 'USA ' },
        { state: 'AR', country: 'USA ' },
        { state: 'AZ', country: 'USA ' },
        { state: 'CA', country: 'USA ' },
        { state: 'CO', country: 'USA ' },
        { state: 'CT', country: 'USA ' },
        { state: 'DC', country: 'USA ' },
        { state: 'DE', country: 'USA ' },
        { state: 'FL', country: 'USA ' },
        { state: 'GA', country: 'USA ' },
        { state: 'HI', country: 'USA ' },
        { state: 'IA', country: 'USA ' },
        { state: 'ID', country: 'USA ' },
        { state: 'IL', country: 'USA ' },
        { state: 'IN', country: 'USA ' },
        { state: 'KS', country: 'USA ' },
        { state: 'KY', country: 'USA ' },
        { state: 'LA', country: 'USA ' },
        { state: 'MA', country: 'USA ' },
        { state: 'MD', country: 'USA ' },
        { state: 'ME', country: 'USA ' },
        { state: 'MI', country: 'USA ' },
        { state: 'MN', country: 'USA ' },
        { state: 'MO', country: 'USA ' },
        { state: 'MS', country: 'USA ' },
        { state: 'MT', country: 'USA ' },
        { state: 'NC', country: 'USA ' },
        { state: 'ND', country: 'USA ' },
        { state: 'NE', country: 'USA ' },
        { state: 'NH', country: 'USA ' },
        { state: 'NJ', country: 'USA ' },
        { state: 'NM', country: 'USA ' },
        { state: 'NV', country: 'USA ' },
        { state: 'NY', country: 'USA ' },
        { state: 'OH', country: 'USA ' },
        { state: 'OK', country: 'USA ' },
        { state: 'OR', country: 'USA ' },
        { state: 'PA', country: 'USA ' },
        { state: 'PR', country: 'USA ' },
        { state: 'RI', country: 'USA ' },
        { state: 'SC', country: 'USA ' },
        { state: 'SD', country: 'USA ' },
        { state: 'TN', country: 'USA ' },
        { state: 'TX', country: 'USA ' },
        { state: 'UT', country: 'USA ' },
        { state: 'VA', country: 'USA ' },
        { state: 'VT', country: 'USA ' },
        { state: 'WA', country: 'USA ' },
        { state: 'WI', country: 'USA ' },
        { state: 'WV', country: 'USA ' },
        { state: 'WY', country: 'USA ' },
      ]);
    });
    return promise;
  }

  public getStatus(state: string): Promise<IWithholdingStatus[]> {
    const promise = new Promise<IWithholdingStatus[]>((resolve) => {
      resolve([
        {
          description: 'Head of Household              ',
          status: 'HOH    ',
        },
        {
          description: 'Married, 0 or 1 Allowance      ',
          status: 'MAR1   ',
        },
        {
          status: 'MAR2   ',
          description: 'Married, 2 or More Allowances  ',
        },
        {
          description: 'Single/Married w/2 Incomes     ',
          status: 'SINGLE ',
        },
      ]);
    });
    return promise;
  }

  public getAlternateCalculationCode(state: string): Promise<ICalculationCode[]> {
    const promise = new Promise<ICalculationCode[]>((resolve) => {
      resolve([
        {
          description: 'test',
          status: '1',
        },
      ]);
    });
    return promise;
  }

  public saveEmployee(data: IServicePersonalInformation): Promise<boolean> {
    const promise = new Promise<boolean>((resolve, reject) => {
      reject('Any reason why');
    });
    return promise;
  }
}
